var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_5863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1273 54.3877C43.6992 54.2477 40.9935 53.0281 42.6842 47.8885H42.66C47.0673 43.3492 50.4354 36.045 50.4354 28.8538C50.4354 17.7965 43.0827 12 34.5373 12C25.9865 12 18.6742 17.7938 18.6742 28.8538C18.6742 36.0746 22.0235 43.4085 26.4577 47.9369C28.1862 52.4708 25.0954 54.1535 24.4492 54.3877C15.5 57.6265 5 63.5254 5 69.3488V71.5323C5 79.4665 20.3838 81.2704 34.6208 81.2704C48.8792 81.2704 64.0692 79.4665 64.0692 71.5323V69.3488C64.0692 63.3504 53.5181 57.4973 44.1273 54.3877ZM29.2765 77.835C29.2765 70.9723 33.6462 61.7081 33.6462 61.7081L30.6227 59.3362C30.6227 57.0692 34.5346 54.6973 34.5346 54.6973C34.5346 54.6973 38.4358 57.1069 38.4358 59.3362L35.4231 61.7081C35.4231 61.7081 39.7927 70.9373 39.7927 77.9104C39.7927 79.0035 29.2765 78.7504 29.2765 77.835Z",
    fill: "white",
    fillOpacity: 0.28
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_5863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon02);
export default __webpack_public_path__ + "static/media/card-icon-02.343356b44b611ca003af551bad874355.svg";
export { ForwardRef as ReactComponent };